<template>
  <div class="w-full border border-divider-200 rounded" v-bind="$attrs" v-on="$listeners">
    <div class="h-10 flex items-center px-4 cursor-pointer select-none" @click="toggleCollapse">
      <OIcon :icon="icon" svg-class="h-3.75 w-3.75 text-o-blue" />
      <span class="text-sm text-o-blue font-bold ml-2.5">{{ title }}</span>
    </div>
    <div v-show="!collapse" class="ml-10 mr-4 my-3">
      <slot />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon },
  props: {
    title: {
      type: String,
      default: '',
    },
    showContent: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const collapse = ref(!props.showContent);
    const toggleCollapse = () => {
      collapse.value = !collapse.value;
    };

    const icon = computed(() => {
      return collapse.value ? 'plus-square' : 'minus-square';
    });

    return {
      icon,
      collapse,
      toggleCollapse,
    };
  },
});
</script>

<style></style>
